<modal-panel title="Filter KT Services" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field>
        <mat-label>Trip Reference</mat-label>
        <input matInput formControlName="TripReference" placeholder="e.g. ABCDEF"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Service Name</mat-label>
        <input matInput formControlName="ServiceName" placeholder="e.g. Hotel Stay"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Product Type</mat-label>
        <input matInput formControlName="ProductTypeName" placeholder="e.g. Hotel"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Vendor Name</mat-label>
        <input matInput formControlName="VendorName" placeholder="e.g. Marriott"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Start Date From</mat-label>
        <input matInput readonly [matDatepicker]="startFrom" formControlName="ServiceStartDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #startFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="startFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Start Date To</mat-label>
        <input matInput readonly [matDatepicker]="startTo" formControlName="ServiceStartDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #startTo/>
        <mat-datepicker-toggle matIconSuffix [for]="startTo"/>
      </mat-form-field>

    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
